'use client';

import type { BigImageTextProps } from '@/core/types';

import React from 'react';

import { Box, Image, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function BigImageText({
  title,
  description,
  image,
  buttons,
  className = '',
  infoClasses = '',
  contentClasses = '',
  imageClasses = '',
}: BigImageTextProps) {
  const isReverse = className.includes('col-reverse');

  return (
    <Box component="section" className={`relative py-16 ${className} `}>
      <Container>
        <Box
          className={`flex flex-col ${isReverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 md:gap-16 items-center ${contentClasses}`}
        >
          <Box className={`w-full lg:w-1/2 ${infoClasses}`}>
            {title && (
              <Typography
                variant="h2"
                className="uppercase md:text-[24px] font-bold mb-2 lg:mb-10 text-primary"
              >
                {title}
              </Typography>
            )}

            {description && (
              <Box
                className="text-base [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-4"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}

            {buttons && buttons.length > 0 && (
              <Box className="flex justify-start mt-2 lg:mt-8 gap-4">
                {buttons.map((button, index) => (
                  <Button
                    key={index}
                    href={button.link}
                    component={RouterLink}
                    variant={button.variant}
                    className={`min-w-[171px] md:min-w-[180px] px-2 md:px-4 text-sm md:text-base ${
                      index === 1 ? '!text-black' : ''
                    } ${button.className}`}
                  >
                    {button.text}
                  </Button>
                ))}
              </Box>
            )}
          </Box>

          <Box className={`w-full lg:w-1/2 xl:w-2/2 ${imageClasses}`}>
            {!!image?.url && (
              <Image
                src={image?.url || ''}
                alt={image?.alt || ''}
                objectFit="contain"
                className="w-full rounded-tl-4xl rounded-br-4xl"
                width={1440}
                height={500}
              />
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
